import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/roofing-repairs")({
  beforeLoad: () => {
    throw redirect({ to: "/services/roof-repair", statusCode: 301 });
  },
});
